import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03e46ccf&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e46ccf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03e46ccf')) {
      api.createRecord('03e46ccf', component.options)
    } else {
      api.reload('03e46ccf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=03e46ccf&scoped=true&", function () {
      api.rerender('03e46ccf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/bonusConfig/index.vue"
export default component.exports